var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCrossSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.167.844a1.133 1.133 0 0 0-1.604 0L8 6.396 2.437.833a1.133 1.133 0 0 0-1.604 0 1.133 1.133 0 0 0 0 1.604L6.396 8 .833 13.563a1.133 1.133 0 0 0 0 1.604c.443.444 1.16.444 1.604 0L8 9.604l5.563 5.563c.444.444 1.16.444 1.604 0a1.133 1.133 0 0 0 0-1.604L9.604 8l5.563-5.563a1.14 1.14 0 0 0 0-1.593Z",
  fill: "#1A1A1A"
})));
export default SvgCrossSmall;